import React, { useState } from "react";
import { InputGroup, FormGroup, Button, Card } from "@blueprintjs/core";
import { useProvideAuth } from "./hooks/use-auth-provider";
import { auth } from "./firebase";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { userLogin } = useProvideAuth();

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = { username, password };
    try {
      userLogin(
        { email: username, password: password },
        async () => {

        },
        () => {}
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login-page" style={{ maxWidth: 400, margin: "auto" }}>
      <Card className="login-card">
        <h3>Sentiment Chat</h3>
        <form onSubmit={handleSubmit}>
          <FormGroup
            label="E-mail"
            labelFor="username-input"
            labelInfo="(gerekli)"
          >
            <InputGroup
              id="username-input"
              placeholder="E-mail"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </FormGroup>
          <FormGroup
            label="Parola"
            labelFor="password-input"
            labelInfo="(gerekli)"
          >
            <InputGroup
              id="password-input"
              placeholder="Parola"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </FormGroup>
          <Button type="submit" intent="primary" text="Oturum Aç" />
        </form>
      </Card>
    </div>
  );
};

export default Login;
